import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

// Context
import { LanguageProvider } from './contexts/LanguageContext';
import { AuthProvider } from './contexts/AuthContext';

// Components
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import LoveStory from './components/LoveStory';
import WeddingDetails from './components/WeddingDetails';
import DressCode from './components/DressCode';
import TipsAndNotes from './components/TipsAndNotes';import SweetMoments from './components/SweetMoments';
import GuestPhotos from './components/GuestPhotos';
import BuenosAires from './components/BuenosAires';
import Gifts from './components/Gifts';
import RSVPForm from './components/RSVPForm';
import BridesmaidSelection from './components/BridesmaidSelection';
import BridesmaidPersonalPage from './components/BridesmaidPersonalPage';
import Footer from './components/Footer';
import AdminDashboard from './components/AdminDashboard';
import LoginForm from './components/LoginForm';

function App() {
  const elementOrder = (
    <>
      <Hero />
      <WeddingDetails />
      <DressCode />
      <TipsAndNotes />
      <SweetMoments />
      <Gifts />
      <GuestPhotos />
      <BuenosAires />
      <Footer />
    </>
  )
  return (
    <AuthProvider>
      <Router>
        <LanguageProvider>
          <div className="App">
            <Navigation />
            
            <Routes>
              {/* English routes (default) */}
              <Route path="/" element={elementOrder} />
              <Route path="/rsvp" element={
                <>
                  <RSVPForm />
                  <Footer />
                </>
              } />
              <Route path="/bridesmaids" element={
                <>
                  <BridesmaidSelection />
                  <Footer />
                </>
              } />
              <Route path="/bridesmaids/:bridesmaidName" element={
                <>
                  <BridesmaidPersonalPage />
                  <Footer />
                </>
              } />
              <Route path="/admin" element={<AdminDashboard />} />
              
              {/* Spanish routes */}
              <Route path="/es" element={elementOrder} />
              <Route path="/es/rsvp" element={
                <>
                  <RSVPForm />
                  <Footer />
                </>
              } />
              <Route path="/es/admin" element={<AdminDashboard />} />
            </Routes>
          </div>
        </LanguageProvider>
      </Router>
    </AuthProvider>
  );
}

export default App;
